import AlertLevels from "constants/alert-levels";
import { siteMap } from "internal-sitemap";
import AlertNotice from "molecules/banners/alert-notice";
import React from "react";
import { Redirect } from "react-router";
import { CitationTokenError } from "utilities/hooks/domain/citations/use-citations-token";
import { t } from "utilities/localization-utils";

interface CitationsErrorNoticeProps {
    errorKey: CitationTokenError | string | undefined;
}

const CitationsErrorNotice = ({ errorKey }: CitationsErrorNoticeProps) => {
    if (!errorKey) {
        return;
    }

    if (errorKey === CitationTokenError.MissingToken) {
        return (
            <AlertNotice
                level={AlertLevels.Warning}
                title={t("citations-error--missing-token")}
            />
        );
    }

    if (errorKey === CitationTokenError.ExpiredToken) {
        return (
            <AlertNotice
                level={AlertLevels.Warning}
                title={t("citations-error--expired-token")}
            />
        );
    } else {
        return <Redirect to={siteMap.errors.notFound} />;
    }
};

export default CitationsErrorNotice;
